export default __webpack_public_path__ + "static/media/screen.2d8f96f2.svg";